module.exports = __webpack_public_path__ + "img/check.04369f47.svg";